angular.module('lingoda.timer', [])
//Requires momentjs
.directive('lingCountdown', ['$interval', function($interval) {
    return {
        restrict:'C',
        scope: true,
        controller: ['$scope', function($scope) {
            $scope.get = function(format) {
                var v = moment.duration($scope.time / 1000, 'seconds').get(format);
                v = v.toString().length == 1 ? '0' + v : v;
                return v;
            };
            $scope.humanize = function() {
                return moment.duration($scope.time / 1000, 'seconds').humanize();
            };
        }],
        link: function(scope, iElement, iAttrs) {

            var intervalID,
                init = function() {

                var from = iAttrs.from,
                    to = iAttrs.to,
                    started = new Date().getTime();

                $interval.cancel(intervalID);

                if(/^\d+$/.test(from)) {
                    from *= 1000;
                } else {
                    from = moment(from).valueOf();
                }

                if(/^\d+$/.test(to)) {
                    to *= 1000;
                } else {
                    to = moment(to).valueOf();
                }

                var reverse = scope.$eval(iAttrs.reverse),
                    sign = reverse ? 1 : (-1);

                iAttrs.limit = iAttrs.limit || 0;

                if(from < to) {
                    from = to;
                }

                scope.from = from - to;
                scope.time = scope.from;

                if(scope.time > 0) {
                    intervalID = $interval(function() {
                        scope.time = scope.from + ((new Date().getTime() - started) * sign);
                        if(
                            (!reverse && scope.time <= iAttrs.limit) ||
                            (reverse && scope.time >= iAttrs.limit)
                        ) {
                            $interval.cancel(intervalID);
                            scope.$broadcast('ling:countdown:stopped');
                        }
                    }, 100);
                }
            };

            init();

            iAttrs.$observe('from', init);
        }
    }
}])
.directive('lingTime', function($interval) {
    return {
        restrict:'C',
        scope: true,
        link: function(scope, iElement, iAttrs) {
            if(/^\d+$/.test(iAttrs.from)) {
                scope.time *= 1000;
            } else {
                scope.time = moment(iAttrs.from).valueOf();
            }

            $interval(function() {
                scope.time = scope.time + 1000;
            }, 1000);
        }
    }
});
